import React from 'react';
import { cloneChildrenWithProps } from '../../../jsCore/utils/reactUtils';


export const FanvoiceItemPlaceholder = ({ blockName, type, isEmpty, children, image }) => {
  const className = `${blockName}__item`;
  const isEmptyModifier = isEmpty ? `${className}--empty` : '';
  const backgroundImage = !image ? {} : { backgroundImage: `url('${image}')` };
  return (
     <li className={ `${className} ${className}--${type} ${isEmptyModifier}` } style={ backgroundImage }>
        { isEmpty ? false : cloneChildrenWithProps(children, {
          blockName,
          modifier: type
        })
        }
     </li>
  );
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/components/fanvoiceItemPlaceholder.js